import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Formation } from '../_models/formation';

@Injectable({
  providedIn: 'root'
})
export class FormationService {

  public searchByNameWorking: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(protected http: HttpClient) { }

  public searchByName(name: string) {
    this.searchByNameWorking.next(true);

    var url = "api/formation/search/" + encodeURIComponent(name);

    var prom = new Promise<Array<Formation>>((resolve, reject) => {
      this.searchByNameWorking.next(true);

      this.http.get(url).toPromise().then((result: Array<Formation>) => {
        this.searchByNameWorking.next(false);
        resolve(result);
      },
        (err) => {
          this.searchByNameWorking.next(false);
          reject(err);
        })
    });

    return prom;
  }
}
